import React from 'react';
import TableFunction from '../../../../components/table/TableFunction';
import { CRITERIA_MODEL, DEFAULT_LEFT, SEARCH_MODEL } from '../../../../components/table/Model/TableModel';
import { SearchByFilters, SimpleSearch } from '../../../../reduxToolkit/Search/SearchApi';
import CustomTh from '../../../../components/table/CustomTh';
import CustomTd from '../../../../components/table/CustomTd';
import { EMPTY_VALUES, errorMsg, getDateFormat, getTimeFormat } from '../../../../Apis/functions';
import {
    DetailsIconsOptions,
    IconChipCircleTools,
    IconClockTable,
    IconDocumentPencil,
    IconEmployeeFactory,
    IconExitDevice,
    IconGuardTitle,
    IconScheduleTable,
} from '../../../../components/buttons/IconButtons';
import { useDispatch, useSelector } from 'react-redux';
import DropDownMenuItem from '../../../../components/DropDown/DropDownMenuItem';
import DropDownMenuProfile from '../../../../components/DropDown/DropDownMenuProfile';
import CustomTooltip from '../../../../components/CustomTooltip';
import CustomImageTable from '../../../../components/CustomImageTable';
import { TABLES } from '../../../../Apis/Tables';
import { permissionObj } from '../../../../Helpers/permission';

const EquipmentAndMaterialTabApp = ({
    finalArray,
    search,
    searchElement,
    setCriteria,
    setSearchResults,
    searchResults,
    setBodyForExport,
    t,
    setItemSelected,
    itemSelected,
    setDetailsModal,
    setCheckOutModal,
    modified,
    setModified,
}) => {
    const tableId = 'tbl_eamta_equipment_and_material';
    const searchId = 'txt_eamta_search_equipment_and_material';
    const option = TABLES.EQUIPMENT_INSIDE;
    const leftPosition = DEFAULT_LEFT;
    const dispatch = useDispatch();
    const DEV = useSelector((state) => state?.CommonsSlice?.development);
    const { permission } = useSelector((state) => state.authenticatioauthennSlice);
    // Registering the missing exit is the only write of the screen, the detail is read only
    const canCheckOut = DEV || permission?.includes(permissionObj?.WEB_UNREGISTERED_EXITS_UPDATE);

    /**
     * Generates table headers.
     * @returns {Array} - Array of table header components.
     */
    const getThead = () => [
        <CustomTh tableId={tableId} fixedXY={true} left={leftPosition} classes='first_head'>
            {t('name')}
        </CustomTh>,
        <CustomTh tableId={tableId}>{t('date_and_time')}</CustomTh>,
        <CustomTh tableId={tableId}>{t('contractor')}</CustomTh>,
        <CustomTh tableId={tableId}>{t('entered_by')}</CustomTh>,
        <CustomTh tableId={tableId}>{t('guard')}</CustomTh>,
    ];

    /**
     * Generates table body content based on data.
     * @returns {Object} - Object containing body content and data array.
     */
    const getTbody = () => {
        const dataSource = searchResults;
        if (!dataSource?.content?.length) {
            return {
                body: [],
                data: [],
            };
        }

        let body = dataSource.content.map((item, index) => {
            return (
                <>
                    <CustomTd tableId={tableId} fixed={true} left={leftPosition} classes={'first-column'}>
                        <CustomImageTable
                            image={IconChipCircleTools}
                            containerClass={'d-flex align-items-center'}
                        >
                            <div className={'ml-1 flex-grow-1 minw-0'}>
                                <div className={'mb-1'}>
                                    <CustomTooltip
                                        text={item?.name || EMPTY_VALUES.DEFAULT}
                                        classes={'fs-14px font-color-text-950 ibl-font-w-600 text-ellipsis'}
                                        showIfTruncated={true}
                                        placement={'top'}
                                    />
                                </div>
                                <div className={'mb-1'}>
                                    <CustomTooltip
                                        text={item?.code || EMPTY_VALUES.DEFAULT}
                                        classes={'fs-14px font-color-text-950 ibl-font-w-400 text-ellipsis'}
                                        showIfTruncated={true}
                                        placement={'top'}
                                    />
                                </div>
                            </div>
                        </CustomImageTable>
                    </CustomTd>
                    <CustomTd tableId={tableId}>
                        <div className={'d-flex'}>
                            <div>
                                <IconScheduleTable className={'mr-8px mb-  h-16px w-16 icon-color-general-950'} />
                            </div>
                            <p className='fs-14px font-color-text-950 ibl-font-w-400'>
                                {getDateFormat(item?.accessDate, false)}
                            </p>
                        </div>
                        <div className={'d-flex'}>
                            <div>
                                <IconClockTable className={'mr-8px mb-1   h-16px w-16 icon-color-general-950'} />
                            </div>
                            <p className='fs-14px font-color-text-950 ibl-font-w-400'>
                                {getTimeFormat(item?.accessDate)}
                            </p>
                        </div>
                    </CustomTd>
                    <CustomTd tableId={tableId}>
                        <div className={'d-flex'}>
                            <IconDocumentPencil className={'mr-8px mb-1  h-16px w-16'} />
                            <CustomTooltip
                                text={item?.contractorName || EMPTY_VALUES.DEFAULT}
                                classes={'fs-14px font-color-text-950 ibl-font-w-400 text-ellipsis'}
                                showIfTruncated={true}
                                placement={'top'}
                            />
                        </div>
                    </CustomTd>
                    <CustomTd tableId={tableId}>
                        <div className={'d-flex'}>
                            <IconEmployeeFactory className={'mr-8px mb-1  h-16px w-16'} />
                            <CustomTooltip
                                text={item?.fullName || EMPTY_VALUES.DEFAULT}
                                classes={'fs-14px font-color-text-950 ibl-font-w-400 text-ellipsis'}
                                showIfTruncated={true}
                                placement={'top'}
                            />
                        </div>
                    </CustomTd>
                    <CustomTd tableId={tableId}>
                        <div className={'d-flex'}>
                            <IconGuardTitle className={'mr-8px mb-1  h-16px w-16'} />
                            <CustomTooltip
                                text={item?.guardFullName || EMPTY_VALUES.DEFAULT}
                                classes={'fs-14px font-color-text-950 ibl-font-w-400 text-ellipsis'}
                                showIfTruncated={true}
                                placement={'top'}
                            />
                        </div>
                    </CustomTd>
                </>
            );
        });
        return {
            body,
           data: dataSource.content,
        };
    };

    const getData = (page) => {
        const body = SEARCH_MODEL.setObject({ page, size: rowsPerPage, model: option, key: searchElement });
        setBodyForExport(body);
        dispatch(SimpleSearch({ body })).then(
            ({
                payload: {
                    data: { data, success, code },
                },
            }) => {
                if (success === true) {
                    setSearchResults(data);
                } else {
                    errorMsg(code);
                }
            },
        );
    };

    const getDataAdvancedSearch = (page) => {
        const body = SEARCH_MODEL.setObject({
            page,
            size: rowsPerPage,
            model: option,
            rootGroup: CRITERIA_MODEL.set(finalArray),
        });
        setCriteria(body);
        dispatch(SearchByFilters({ option, body })).then(
            ({
                payload: {
                    data: { data, success, code },
                },
            }) => {
                if (success === true) {
                    setSearchResults(data);
                } else {
                    errorMsg(code);
                }
            },
        );
    };
    const getActionsButtons = (item, index) => {
        return (
            <>
                <DropDownMenuProfile openMenu={openMenu} handleMenuToggle={handleMenuToggle} menuId={`menu-${item.id}`}>
                    <DropDownMenuItem
                        id={'btn_eamta_details_' + item?.id}
                        index={index}
                        handleClose={handleClose}
                        name={t('details')}
                        click={() => {
                            setItemSelected(item);
                            setDetailsModal(true);
                        }}
                        icon={<DetailsIconsOptions />}
                    />
                    {canCheckOut && (
                        <DropDownMenuItem
                            id={'btn_eamta_checkout_' + item?.id}
                            index={index}
                            handleClose={handleClose}
                            name={t('checkout')}
                            click={() => {
                                setItemSelected(item);
                                setCheckOutModal(true);
                            }}
                            icon={<IconExitDevice />}
                        />
                    )}
                </DropDownMenuProfile>
            </>
        );
    };

    const { thead, tbody, pagination, page, rowsPerPage, openMenu, handleMenuToggle, handleClose } = TableFunction({
        data: searchResults,
        getThead,
        getTbody,
        hasContainer: true,
        labelRowsPerPage: 'equipment_per_page',
        fixedPagination: false,
        searchElement,
        getData,
        modified,
        setModified,
        getDataAdvancedSearch,
        finalArray,
    });

    return {
        option,
        rowsPerPage,
        tableId,
        searchId,
        thead,
        tbody,
        getActionsButtons,
        pagination,
    };
};

export default EquipmentAndMaterialTabApp;
